import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
export function template() {
  const tutorialUrl = this.attr("custom-url") || "https://www.youtube.com/embed/PbKnQ777vuk";
  const title = this.attr("title");
  return /* @__PURE__ */ jsx(ModalEl, { sel: "#media-modal", attrs: {
    open: this.state.isModalOpen,
    closeable: true,
    "modal-title": title,
    "grow-to-content": true
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".modal-container" }, /* @__PURE__ */ jsx("div", { sel: ".modal-title" }, title), /* @__PURE__ */ jsx("div", { sel: ".modal-content" }, /* @__PURE__ */ jsx("div", { sel: ".video-container" }, /* @__PURE__ */ jsx(SpinnerEl, { sel: "#tutorial-spinner", attrs: {
    size: SpinnerSize.Large
  }, "data-sentry-element": "SpinnerEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("iframe", { sel: "#tutorial-iframe", attrs: {
    frameborder: "0",
    allow: "autoplay",
    src: tutorialUrl,
    width: this.attr("width") || 560,
    height: this.attr("height") || 315,
    allowfullscreen: true
  } })))));
}
